import { Form, Input, Modal } from "antd";
import React from "react";

export const ModalCreatePk = ({ visible, onCancel, onOk }) => {
  const [form] = Form.useForm();

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      onOk={() => form.submit()}
      afterClose={() => form.resetFields()}
    >
      <p>Deseja realmente criar uma PK para esse campo?</p>
      <Form form={form} layout="vertical" onFinish={onOk}>
        <Form.Item
          name="ticket"
          label="Ticket:"
          rules={[{ required: true, whitespace: true, message: "Informe o ticket." }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
